var map = {
	"./angiang.png": 4402,
	"./baclieu.png": 7597,
	"./bentre.png": 7920,
	"./binhdinh.png": 4041,
	"./binhduong.png": 8519,
	"./binhphuoc.png": 524,
	"./binhthuan.png": 7137,
	"./camau.png": 407,
	"./cantho.png": 3946,
	"./daklak.png": 4231,
	"./daknong.png": 6628,
	"./dalat.png": 1908,
	"./danang.png": 8076,
	"./dongnai.png": 2711,
	"./dongthap.png": 9435,
	"./gialai.png": 2509,
	"./haugiang.png": 9594,
	"./hue.png": 1572,
	"./khanhhoa.png": 1854,
	"./kiengiang.png": 8037,
	"./komtum.png": 682,
	"./longan.png": 638,
	"./mienbac.png": 1162,
	"./ninhthuan.png": 3425,
	"./phuyen.png": 501,
	"./quangbinh.png": 3898,
	"./quangnam.png": 2970,
	"./quangngai.png": 3185,
	"./quangtri.png": 2179,
	"./soctrang.png": 5370,
	"./tayninh.png": 9822,
	"./tiengiang.png": 34,
	"./tphcm.png": 5865,
	"./travinh.png": 9131,
	"./vinhlong.png": 6117,
	"./vungtau.png": 1209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1233;